import { Component, OnInit } from '@angular/core';
import { Validators, FormGroup, FormControl, FormBuilder } from "@angular/forms";
import { Router } from '@angular/router';

@Component({
  selector: 'app-sidebar-left-inner',
  templateUrl: './sidebar-left-inner.component.html'
})
export class SidebarLeftInnerComponent implements OnInit {
    
    public searchForm: FormGroup;
    
    constructor(private fb: FormBuilder,private router: Router) {}

    ngOnInit() {
        this.searchForm = this.fb.group({
          serialnumber: ['', Validators.required]
        })
    }
    
    public submitSearch() : void {
        if(this.searchForm.valid){
            this.router.navigate(['/assets/' + this.searchForm.value.serialnumber ])
        }
    }
}
